<template>
    <div class="form-sales-land-modal" v-if="salesCard != null">
        <button class="btn-close-form-modal" @click="closeFormModal()"><svgIcon name="close" class="icon-close"/></button>
        <div class="form-titles" v-if="formVisible">
            <div class="form-bg" :style="'background-image: url(' + salesCard.project_drop_modal_form.form_img + ')'"></div>
            <div class="titles">
                <h3>{{salesCard.project_drop_modal_form.form_title}}</h3>
                <span>{{salesCard.project_drop_modal_form.form_title_desc}}</span>
            </div>
        </div>
        <div class="form-modal-container">
            <form class="form_call-modal">
                <div class="form-in" :class="{fadeOut : !formVisible, 'disabled-form' : formDisabled}" v-if="formVisible">
                    <div class="form-group form-text">
                        <input type="text" name="name" class="form-control" :placeholder="salesCard.shablon_form_name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                    </div>
                    <div class="form-group form-phone">
                        <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" placeholder="+7 (" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phoneRegex }" data-vv-delay="1000"/>
                    </div>
                    <VueRecaptcha
                        ref="recaptchaLandModal"
                        @verify="onCaptchaVerified"
                        @expired="onCaptchaExpired"
                        :sitekey="salesGcap_siteKey"
                        size="invisible"
                    />
                    <div class="btn-send">
                        <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">{{salesCard.shablon_form_btn}}</button>
                        <span class="error-message" v-show="errors.has('name') || errors.has('phone')">Заполните все поля</span>
                    </div>
                </div>
                <div class="successMessage" v-if="!formVisible">
                    <h3>Спасибо! Ваша заявка отправлена.</h3>
                </div>
            </form>
            <div class="privacy-desc" v-if="projectHost != 'nurly-dala2' && formVisible" :class="{'privacy-desc-white' : projectHost == 'duman'}">
                <p>
                    <span>{{ salesCard.shablon_form_privacy_desc.one }}</span> 
                    «<span>{{ salesCard.shablon_form_btn }}</span>» <br>
                    <span class="two">{{ salesCard.shablon_form_privacy_desc.two }}</span>
                    <span><a href="https://sales.bazis.kz/privacy-policy" target="_blank">{{ salesCard.shablon_form_privacy_desc.word }}</a></span>
                    <span class="three">{{ salesCard.shablon_form_privacy_desc.three }}</span>
                </p>
            </div>
            <div class="to-many-requests-msg" v-if="toManySendingMsg">
                <span v-if="globalLang == ''">Вы отправили слишком много заявок, попробуйте позднее</span>
                <span v-if="globalLang == 'kz/'">Сіз жіберді тым көп өтінімдерді көріңіз кешіктірмей</span>
                <span v-if="globalLang == 'en/'">You have sent too many requests, please try again later</span>
            </div>
        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import { VueRecaptcha } from 'vue-recaptcha';
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import cookie from 'vue-cookie'
    import {mapGetters} from 'vuex'
    export default {
        name: 'FormConsultLandModal',
        data () {
            return {
                globalLang: window.GlobalLang, 
                toManySendingMsg: false,
                phone: '',
                name: '',
                quest: '',
                admin_mail: '',
                agree: false,
                formVisible: true,
                formDisabled: false,
                utmUrlParams: {},
                errorMsg: false,
                currentPhone: null,
                projectHost: window.host,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                    phoneRegex: /^\+7\s?\((700|701|702|703|704|705|706|707|708|709|747|771|775|776|777|778)\)\s?\d{3}-\d{2}-\d{2}$/,
                }
            }
        },
        components: {
            MaskedInput,
            VueRecaptcha,
            svgIcon,
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesGcap_siteKey: 'loadGcap_sitekey',
        }),
        methods: {
            onCaptchaVerified(response) {
                let submissionCounter = localStorage.getItem('formPage_submissionCounter') || 0;
                let lastSubmissionTime = localStorage.getItem('formPage_lastSubmissionTime') || 0;
                var currentMinutes = this.getCurrentMinutes();
                if (currentMinutes - lastSubmissionTime >= 5) {
                    submissionCounter = 0;
                }
                if (submissionCounter >= 5) {
                    this.toManySendingMsg = true;
                    console.log('Превышен лимит отправок формы. Пожалуйста, подождите некоторое время.');
                    return;
                }
                // console.log(response)
                console.log('flat modal start sending verify is complete');
                this.getQueryParams(submissionCounter, lastSubmissionTime);
                // var data = {
                //     'norep': 'noreplay@' + window.host + '.bazis.kz',
                //     'name': this.name,
                //     'phone': this.phone,
                //     'project' : this.salesCard.project_name.slug,
                //     'city' : this.salesCard.city_name.name,
                //     'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ==',
                // };
                // this.formVisible = false;
                // // console.log(data)
                // axios.post('https://admin.shablon.bazis.kz/server/form-call.php', querystring.stringify(data))
                // .then(() => {
                //     submissionCounter++;
                //     localStorage.setItem('formPage_submissionCounter', submissionCounter);
                //     localStorage.setItem('formPage_lastSubmissionTime', currentMinutes);
                //     dataLayer.push({'event' : 'form_sent'})
                // })
                // .catch(error => {
                //     console.error('Form Flat Modal submission error:', error);
                // });
            },
            onCaptchaExpired() {
                console.log('capcha expired');
                // Handle expiration
            },
            sendData() {
                this.$validator.validate().then(result => {
                    if(result) {
                        // console.log('land modal - all ok')
                        this.$refs.recaptchaLandModal.execute();
                    } else {
                        console.log('Form inputs with errors');
                    }
                });
            },
            getQueryParams(counter, time) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                for (const [key, value] of urlParams.entries()) {
                    this.utmUrlParams[key] = value;
                }
                this.sendDataCRM(counter, time);
            },
            sendDataCRM(counter, time) {
                this.formDisabled = true;
                var dataForm = {
                    leadName: this.name,
                    phone: this.normalizePhone(this.phone),
                    complex: this.salesCard.project_name.slug,
                    email: '',
                    advertisingChannel: "Личный кабинет",
                    requestWebsite: window.host + '.bazis.kz',
                    description:
                    "Form Modal" +
                    (this.utmUrlParams.utm_source ? ` | Utm Source: ${this.utmUrlParams.utm_source}` : '') +
                    (this.utmUrlParams.utm_medium ? ` | Utm Medium: ${this.utmUrlParams.utm_medium}` : '') +
                    (this.utmUrlParams.utm_campaign ? ` | Utm Campaign: ${this.utmUrlParams.utm_campaign}` : '') +
                    (this.utmUrlParams.utm_content ? ` | Utm Content: ${this.utmUrlParams.utm_content}` : '') +
                    (this.utmUrlParams.utm_term ? ` | Utm Term: ${this.utmUrlParams.utm_term}` : ''),
                    utmSource: this.utmUrlParams.utm_source,
                    utmMedium: this.utmUrlParams.utm_medium,
                    utmCampaign: this.utmUrlParams.utm_campaign,
                    utmContent: this.utmUrlParams.utm_content,
                    utm_term: this.utmUrlParams.utm_term
                }
                // console.log(dataForm)
                // console.log(this.utmUrlParams);
                // console.log(this.crm_auth_key);
                this.$store.dispatch('sendFormDataToCRM', dataForm).then((response) => {
                    if (response.status == 200) {
                        this.formVisible = false;
                        counter++;
                        localStorage.setItem('Lumiere_submissionCounter', counter);
                        localStorage.setItem('Lumiere_lastSubmissionTime', time);
                        dataLayer.push({'event' : 'form_sent'});
                    } else {
                        alert('Ошибка при отправке формы - обратитесь в Call Center');
                    }
                });
            },
            normalizePhone(phone) {
                const digits = phone.replace(/\D/g, '');
                if (digits.length !== 11 || !digits.startsWith('7')) {
                    return null;
                }
                const code = digits.slice(1, 4);
                const part1 = digits.slice(4, 7);
                const part2 = digits.slice(7, 9);
                const part3 = digits.slice(9, 11);
                return `+7 ${code} ${part1} ${part2} ${part3}`;
            },
            getCurrentMinutes() {
                return Math.floor(new Date().getTime() / (1000 * 60));
            },
            closeFormModal() {
                // console.log('close form modal');
                // cookie.set(window.host + '_form_land_modal_timer', true, { expires: '10' + 's' });
                cookie.set(window.host + '_form_land_modal_timer', true, { expires: this.salesCard.project_drop_modal_form.minutes + 'm' });
                this.$store.commit('Open_FormLandModal', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                this.phone = '';
                this.name = '';
            },
        },
        beforeCreate() {
            // this.$store.dispatch('getFormsData');
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-land-modal.scss';
</style>